import { Pipe, PipeTransform } from '@angular/core';
import { Menu } from '../../../models/menu/menu';
import { SectionWithProducts } from '../../../models/menu/section/section-with-products';

@Pipe({
  name: 'getSectionBorderColor',
  standalone: false
})
export class GetSectionBorderColorPipe implements PipeTransform {
  transform(menu: Menu, section: SectionWithProducts): string {
    return section?.getBorderColor(menu);
  }
}
